__turbopack_context__.v({
  "logo": "EarlyAccessStrip-module-scss-module__hnhyoG__logo",
  "phaseOpen": "EarlyAccessStrip-module-scss-module__hnhyoG__phaseOpen",
  "strip": "EarlyAccessStrip-module-scss-module__hnhyoG__strip",
});
